const PostCodeService = require("./postCodeService");
const UserService = require("./userService");
const AuthService = require("./authService");
const SeminarService = require("./seminarService");

export { PostCodeService, UserService, AuthService, SeminarService };
